import { FooterType, getGlobalFooterID } from '@configs/quarkFooter.config'
import { getIcon } from '@configs/quarkIcons.config'
import { ContentType } from '@enums/ContentType'
import { FooterDataType } from '@quark/footer'
import { getEntryFromCMSUsingId } from '@services/strapiService'

/**
 * Fetches and returns the appropriate footer data for the URL, returns default if no url provided
 * @param url url of the page
 * @returns the footer data of the corresponding page
 */
export const getFooterData = async (env: string, url?: string) => {
  const pageType: string[] = url?.split('/') || []
  let footerType = FooterType.DEFAULT
  if (pageType.includes('gi')) {
    footerType = FooterType.GI
  } else if (pageType.includes('life')) {
    footerType = FooterType.LIFE
  }
  const data = await getEntryFromCMSUsingId({
    contentType: ContentType.GlobalFooter,
    contentId: getGlobalFooterID(env, footerType),
  })
  return data?.attributes
}

export const parseFooterData = (data: any, homePage: boolean): FooterDataType => {
  if (!data) return {}
  return {
    companyInfo: {
      companyAddress: data?.companyInfo?.companyAddress,
      logoUrl: data?.companyInfo?.logoUrl,
      companyName: data?.companyInfo?.companyName,
      socialNetworkPlatforms: data?.companyInfo?.socialNetworkPlatforms?.map(platform => ({
        logo: getIcon(platform?.logo),
        link: platform?.link,
      })),
    },
    policyInfo: {
      wordings: homePage
        ? [
          ...data.policyInfo.wordings.slice(0, 1),
          {
            text: '*Listed #1 for “insurance” on the Apple App Store',
          },
          ...data.policyInfo.wordings.slice(1),
        ]
        : data?.policyInfo?.wordings,
      logos: data?.policyInfo?.logos?.map(partner => ({
        logo: getIcon(partner?.logo),
        link: partner?.link,
      })),
    },
    categories: [
      ...data?.options?.data?.map(category => ({
        categoryName: category?.attributes?.title,

        ...(category?.attributes.options?.length > 0 && {
          options: category?.attributes.options?.map(option => ({
            name: option?.title,
            url: option?.url,
            openInNewTab: option?.openInNewTab,
          })),
        }),
      })),
      ...data?.accordions?.data.map(accordion => ({
        categoryName: accordion?.attributes?.title,
        ...(accordion?.attributes.options?.data?.length > 0 && {
          subCategories: accordion?.attributes?.options?.data?.map(subCategory => ({
            subCategoryName: subCategory?.attributes?.title,
            ...(subCategory?.attributes?.options?.length > 0 && {
              options: subCategory.attributes?.options?.map(option => ({
                name: option?.title,
                url: option?.url,
                openInNewTab: option?.openInNewTab,
              })),
            }),
          })),
        }),
      })),
    ],
  }
}
